@use "../../../../../../../styles/Constants.scss" as Constants;

.approval-actions {
	margin-top: Constants.$val-spacing-m;
	display: flex;
}